(function (Drupal, once) {
  Drupal.behaviors.flexiMedia = {
    attach: function (context, settings) {
      once('media', '.zoomable-media').forEach((element) => {
        const popupContainer = document.querySelector(".media-popup__container");
        const mediaElement = element.querySelector(".media");
        
        element.addEventListener("click", () => {

          if (popupContainer.childElementCount === 0) {
                const clonedMediaElement = mediaElement.cloneNode(true);
                popupContainer.appendChild(clonedMediaElement);

                const popupElement = document.querySelector(".media-popup");
                popupElement.classList.add("opened");

                // Disable scrolling on the page
                document.body.style.overflow = "hidden";
          }
        });
      });
    }
  };
})(Drupal, once);
  
window.addEventListener('load', () => {
    function closePopup() {
        const popupElement = document.querySelector(".media-popup");
        popupElement.classList.remove("opened");

      const popupContainer = document.querySelector(".media-popup__container");
      popupContainer.innerHTML = "";

      document.body.style.overflow = "auto";
    }

    const mediaCloseBtn = document.querySelector(".media-popup--close");
    if(mediaCloseBtn) {
        mediaCloseBtn.addEventListener("click", () => {
            closePopup();
        })
    }

    document.addEventListener("click", function(event) {
        const mediaElements = document.querySelectorAll(".zoomable-media");
        const popupContainer = document.querySelector(".media-popup__container");
        
        let clickedOutside = true;
        
        mediaElements.forEach((mediaElement) => {
          if (mediaElement.contains(event.target)) {
            clickedOutside = false;
          }
        });
      
        if (popupContainer.contains(event.target)) {
          clickedOutside = false;
        }
      
        if (clickedOutside) {
          closePopup();
        }
      });
      
})